import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { routing } from './features.routing';

import { FeaturesComponent } from './features/features.component';
import { FeaturesStep1Component } from './features/features-step1/features-step1.component';
import { FeaturesStep2Component } from './features/features-step2/features-step2.component';
import { FeaturesStep3Component } from './features/features-step3/features-step3.component';
import { FeaturesStep4Component } from './features/features-step4/features-step4.component';
import { FeaturesStep5Component } from './features/features-step5/features-step5.component';
import { FeaturesCartCheckoutComponent } from './features/features-cart-checkout/features-cart-checkout.component';
import { CartSuccessComponent } from './features/cart-success/cart-success.component';

@NgModule({
	imports: [
		routing,
		SharedModule,
	],
	declarations: [
		FeaturesComponent,
		FeaturesStep1Component,
		FeaturesStep2Component,
		FeaturesStep3Component,
		FeaturesStep4Component,
		FeaturesStep5Component,
		FeaturesCartCheckoutComponent,
		CartSuccessComponent,
	],
})
export class FeaturesModule { }
